<template>
  <div class="text-center padding" :class="{'white': $store.state.slide.textColour == '#ffffff'}">
    <div v-if="slide.title || slide.subheading">
      <h2
        class="mt-0 title slide-title-style"
        v-html="dataValue"
      />
      <p class="subheading" :inner-html.prop="slide.titleDesc | sanitize(true)" />
    </div>

    <!-- no content -->
    <div class="no-data" v-if="!slide.title && !slide.titleDesc">
      <h2 class="mt-0 title slide-title-style">
        Ask me anything!
      </h2>
    </div>

    <div
      class="audio-control-slide"
      v-if="slide.audioLink
        && slide.audioPlayOnAudience && slide.id"
    >
      <AudioControl />
    </div>

    <div class="img-slide" v-if="slide.image">
      <img :src="slide.image.large" alt="">
    </div>
  </div>
</template>
<script>
import AudioControl from '@/components/AudioControl.vue'
import { mapState } from 'vuex'
import ClickableTitleMixin from '@/mixins/ClickableTitleMixin'

export default {
  components: {
    AudioControl,
  },
  mixins: [ClickableTitleMixin],
  computed: {
    ...mapState({
      slide: (state) => state.slide,
    }),
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.audio-control-slide {
  margin-bottom: 16px;
}
.img-slide {
  margin-bottom: 16px;
  img {
    max-width: 100%;
  }
}

.title {
  margin-bottom: 0;
}
.img-caption {
  font-size: 18px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.icobutton--haha.active {
  span {
    color: $reaction-smiley-color !important;
  }
}
.icobutton--heart.active {
  span {
    color: rgb(243, 81, 134) !important;
  }
}
.icobutton--question.active {
  span {
    color: rgb(111, 151, 247) !important;
  }
}
.icobutton--like.active {
  span {
    color: $reaction-thumbs-up-color !important;
  }
}
.icobutton--dislike.active {
  span {
    color: rgb(255, 103, 103) !important;
  }
}
.text-center {
  text-align: center;
}

.padding {
  padding: 0 16px;
}

.title {
  font-weight: bold;
  font-size: 28px;
  margin-bottom: 16px;
}

.subheading {
  margin: 0;
  font-size: 18px;
  height: 100%;
  white-space: pre-line;
  line-height: 25px;
  opacity: 0.7;
  margin-bottom: 16px;
}

.popup-enter-active {
  transition: all 0.4s ease;
}
.popup-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
  transform: scale(1.5);
}
.popup-enter, .popup-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: scale(0.5);
  opacity: 0;
}
.bullet-list {
  text-align: left;

  li {
    margin-bottom: 8px;
  }
}
</style>
